module.exports = __webpack_public_path__ + "static/img/history-img.38d3082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-img.png
// module id = B4hT
// module chunks = 1